// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectDevelopers_CreateToken($expires_at: numeric!, $description: String!) {
  auth_api_user_register(description: $description, expires_at: $expires_at) {
    key
    secret
  }
}

`